import {
    CodeTwoTone,
    DeleteTwoTone,
    EditTwoTone,
    PlusOutlined,
    ProfileTwoTone,
    QuestionCircleOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import {
    Button,
    Card,
    Checkbox,
    Drawer,
    Form,
    Input,
    InputNumber,
    Modal,
    notification,
    Popconfirm,
    Select,
    Skeleton,
    Upload,
} from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { encrypt, getBase64, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

const { Option } = Select;

function ServerInstances() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const userRole = getUserRole();
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
        sorting: 1,
        sort_by: "updated_at",
    });
    const [drawerVisibility, setDrawerVisibility] = useState(false);
    const [addEditModalVisible, setAddEditModalVisible] = useState(false);
    const [title, setTitle] = useState(false);
    const [form] = Form.useForm();
    const [runCommandModalVisible, setRunCommandModalVisible] = useState(false);
    const [runCommandForm] = Form.useForm();
    const [historyTableData, setHistoryTableData] = useState([]);
    const [totalHistoryRecords, setTotalHistoryRecords] = useState(0);
    const [historyFormData, setHistoryFormData] = useState({
        staff_id,
        limit: 10,
        page: 0,
    });

    const columns = [
        {
            title: " Server Name",
            dataIndex: "server_name",
            key: "server_name",
        },
        {
            title: "Host",
            dataIndex: "host",
            key: "host",
        },
        {
            title: "Jump Host",
            dataIndex: "jump_host",
            key: "jump_host",
        },
        {
            title: "Private Key",
            dataIndex: "private_key",
            key: "private_key",
        },
        {
            title: "Jump Private Key",
            dataIndex: "jump_private_key",
            key: "jump_private_key",
        },
        {
            title: "Logs File Name",
            dataIndex: "logs_file_name",
            key: "logs_file_name",
        },
        {
            title: "Docker Instance Name",
            dataIndex: "docker_instance_name",
            key: "docker_instance_name",
        },
        {
            title: "Service Type",
            dataIndex: "service_type",
            key: "service_type",
            render: (text, record) => (
                <span>
                    {record.is_service
                        ? text == 1
                            ? "Nginx"
                            : text == 2
                            ? "Mongo"
                            : "Docker"
                        : "-"}
                </span>
            ),
        },
        {
            title: "Action",
            render: (record) => (
                <>
                    {(userRole == "Super Admin" ||
                        userRole == "Admin" ||
                        userRole == "Support") && (
                        <Popconfirm
                            onConfirm={() => deleteRecord(record.id)}
                            title="Are you sure want to delete?"
                            icon={
                                <QuestionCircleOutlined
                                    style={{
                                        color: "red",
                                    }}
                                />
                            }
                        >
                            <DeleteTwoTone
                                className="actionIcon"
                                disabled={false}
                            />
                        </Popconfirm>
                    )}
                    <EditTwoTone
                        className="actionIcon"
                        id={record.id}
                        onClick={() => editRecord(record)}
                    />
                    {(userRole == "Super Admin" ||
                        userRole == "Admin" ||
                        userRole == "Support") && (
                        <CodeTwoTone
                            className="actionIcon"
                            onClick={() => openRunCommandSelection(record.id)}
                        />
                    )}
                    <ProfileTwoTone
                        className="actionIcon"
                        id={record.id}
                        onClick={showHistory}
                    />
                </>
            ),
        },
    ];

    const {
        status: serverListStatus,
        data: serverListRes,
        refetch: getserverList,
    } = useQuery(
        "server-instances",
        async () => {
            return await HTTP("/server/getServers", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getserverList();
    }, []);

    useEffect(() => {
        getserverList();
    }, [formData]);

    useEffect(() => {
        if (serverListStatus === "success") {
            const { data: tableData, total } = serverListRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [serverListStatus, serverListRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const newFormData = { ...formData, ...others };
        setFormData(newFormData);
    }

    function openAddModal() {
        setTitle("Add");
        setAddEditModalVisible(true);
    }

    function closeAddEditModal() {
        form.resetFields();
        setAddEditModalVisible(false);
    }

    async function handleSubmit(value) {
        if (!value.is_service) value.service_type = 0;
        console.log("values", value);
        let url = "/server/addServer";
        if (value.id && value.id != "") url = "/server/editServer";
        const { success, data, message } = await HTTP(url, {
            ...value,
            staff_id,
        });
        if (success) {
            getserverList();
            notification["info"]({
                message: "Action performed successfully.",
            });
        } else {
            notification["error"]({
                message: message,
            });
        }
        closeAddEditModal();
    }

    async function deleteRecord(id) {
        const { success, data, message } = await HTTP("/server/deleteServer", {
            staff_id,
            id,
        });
        if (success) {
            getserverList();
            notification["info"]({
                message: "Action performed successfully.",
            });
        } else {
            notification["error"]({
                message: message,
            });
        }
    }

    async function editRecord(record) {
        setTitle("Edit");
        record.service_type == 0 && delete record.service_type;
        form.setFieldsValue(record);
        setAddEditModalVisible(true);
    }

    async function showHistory(e) {
        const newFormData = {
            ...historyFormData,
            sorting: 1,
            sort_by: "updated_at",
            server_id: e.currentTarget.getAttribute("id"),
        };
        setHistoryFormData(newFormData);
        const { success, data, message, total } = await HTTP(
            "/server/getServerCommandHistory",
            newFormData,
        );

        if (success) {
            setHistoryTableData(data);
            setTotalHistoryRecords(total);
            setDrawerVisibility(true);
        } else {
            notification["error"]({
                message: message,
            });
        }
    }

    function openRunCommandSelection(id) {
        runCommandForm.setFieldsValue({ id });
        setRunCommandModalVisible(true);
    }

    async function handleCommandFormSubmit(values) {
        const { success, message } = await HTTP("/server/runCommand", {
            ...values,
            password: encrypt(values.password),
            staff_id,
        });
        if (success) {
            notification["info"]({ message: message });
        } else {
            notification["error"]({ message: message });
        }
        closeCommandModal();
    }

    function closeCommandModal() {
        runCommandForm.resetFields();
        setRunCommandModalVisible(false);
    }

    function importList(info) {
        if (info.file.status === "error") {
            getBase64(info.file.originFileObj, async (imageUrl) => {
                const formData = {
                    staff_id,
                    file_name: info.file.name,
                    file_path: imageUrl,
                };
                const { success, data, message } = await HTTP(
                    "/server/uploadServerCsv",
                    {
                        ...formData,
                    },
                );
                if (!success) {
                    notification["error"]({
                        message,
                    });
                } else {
                    getserverList();
                }
            });
        }
    }

    function closeDetailsDrawer() {
        setDrawerVisibility(false);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        <div>
                            {(userRole === "Super Admin" ||
                                userRole === "Admin") && (
                                <Button
                                    type="primary"
                                    className="margin-right-5 margin-left-5"
                                    onClick={openAddModal}
                                >
                                    <PlusOutlined /> Add
                                </Button>
                            )}
                            {(userRole === "Super Admin" ||
                                userRole === "Admin" ||
                                userRole === "Support") && (
                                <Upload
                                    accept=".csv , .xlsx"
                                    onChange={importList}
                                    showUploadList={false}
                                >
                                    <Button
                                        className="margin-right-5"
                                        type="primary"
                                        icon={<UploadOutlined />}
                                    >
                                        Import
                                    </Button>
                                </Upload>
                            )}
                        </div>
                    }
                />
                <Card className="box-shadow margin-10">
                    {serverListStatus === "loading" ||
                    serverListStatus === "idle" ? (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    ) : (
                        <CustomTable
                            columns={columns}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            rowKey="id"
                            className="serrver-queue-table"
                        />
                    )}
                </Card>
            </Card>
            <Modal
                title={title}
                destroyOnHidden
                open={addEditModalVisible}
                onCancel={closeAddEditModal}
                footer={""}
            >
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 10,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={handleSubmit}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Name"
                        name="server_name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Server Name..!!",
                            },
                        ]}
                    >
                        <Input id="server_name" />
                    </Form.Item>
                    <Form.Item
                        label="Host"
                        name="host"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Host..!!",
                            },
                        ]}
                    >
                        <Input id="host" />
                    </Form.Item>
                    <Form.Item
                        label="Jump Host"
                        name="jump_host"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Jump Host..!!",
                            },
                        ]}
                    >
                        <Input id="jump_host" multiple />
                    </Form.Item>
                    <Form.Item
                        label="User Name"
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter User Name..!!",
                            },
                        ]}
                    >
                        <Input id="username" />
                    </Form.Item>
                    <Form.Item
                        label="Private Key"
                        name="private_key"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Private Key..!!",
                            },
                        ]}
                    >
                        <Input id="private_key" />
                    </Form.Item>
                    <Form.Item
                        label="Jump Private Key"
                        name="jump_private_key"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Jump Private Key..!!",
                            },
                        ]}
                    >
                        <Input id="jump_private_key" />
                    </Form.Item>
                    <Form.Item label="Logs File Name" name="logs_file_name">
                        <Input id="logs_file_name" />
                    </Form.Item>
                    <Form.Item
                        label="Docker Instance Name"
                        name="docker_instance_name"
                    >
                        <Input id="docker_instance_name" />
                    </Form.Item>
                    <Form.Item label="Process ID" name="process_id">
                        <InputNumber id="process_id" min={0} defaultValue={0} />
                    </Form.Item>
                    <Form.Item
                        label="Is a service instance?"
                        name="is_service"
                        valuePropName="checked"
                    >
                        <Checkbox id="is_service" />
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.is_service !== currentValues.is_service
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("is_service") === true && (
                                <Form.Item
                                    label="Service Type"
                                    name="service_type"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please Select Service type..!!",
                                        },
                                    ]}
                                >
                                    <Select id="service_type">
                                        <Option value={1}>Nginx</Option>
                                        <Option value={2}>MongoDB</Option>
                                        <Option value={3}>Docker</Option>
                                    </Select>
                                </Form.Item>
                            )
                        }
                    </Form.Item>
                    <Form.Item name="id" className="hidden">
                        <Input id="id" disabled></Input>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="Guest Details"
                destroyOnHidden
                open={runCommandModalVisible}
                onCancel={closeCommandModal}
                footer={""}
            >
                <Form
                    form={runCommandForm}
                    name="basic"
                    labelCol={{
                        span: 10,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={handleCommandFormSubmit}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Commnad"
                        name="command_type"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Command To Run..!!",
                            },
                        ]}
                    >
                        <Select id="Command Type">
                            <Option value="1">Restart</Option>
                            <Option value="2">Delete Logs</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: "Please enter email!",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Email"
                            id="email"
                            className="upcoming-form-inputs"
                        ></Input>
                    </Form.Item>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please enter password!",
                            },
                        ]}
                    >
                        <Input.Password
                            type="password"
                            placeholder="Password"
                            id="password"
                            className="upcoming-form-inputs"
                        ></Input.Password>
                    </Form.Item>
                    <Form.Item name="id" className="hidden">
                        <Input id="id" disabled></Input>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Drawer
                placement="right"
                destroyOnHidden
                title="Details"
                open={drawerVisibility}
                onClose={closeDetailsDrawer}
            >
                <div
                    style={{
                        width: "30vw",
                        margin: "15px",
                    }}
                >
                    <CustomTable
                        columns={[
                            {
                                title: "Server Name",
                                dataIndex: "server_name",
                                key: "server_name",
                            },
                            {
                                title: "Action",
                                dataIndex: "command_type",
                                render: (text) =>
                                    text == 1
                                        ? "Restarted Server"
                                        : "Deleted Log",
                            },
                            {
                                title: "Action By",
                                render: (_, record) =>
                                    `${record.first_name} ${record.last_name}`,
                            },
                        ]}
                        tableData={historyTableData}
                        noOfrecords={totalHistoryRecords}
                        pagination={false}
                        rowKey="id"
                        className="serrver-queue-table"
                    />
                </div>
            </Drawer>
        </>
    );
}

export { ServerInstances };
